import React, { useCallback, useRef, useState } from "react";
import { Avatar, Button, Card, Typography } from "@mui/material";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";

export default function Cards() {
  return (
    <>
      <div className="flex flex-col sm:flex sm:flex-row px-16 mb-8">
        <div className="w-full sm:w-1/4 p-16">
          <Card className="relative flex flex-col flex-auto rounded-2xl shadow p-16">
            <div className="flex items-center">
              <Avatar sx={{ bgcolor: '#0597EA'}}>
                <FuseSvgIcon size={24} color="action">
                  material-outline:add_to_queue
                </FuseSvgIcon>
              </Avatar>
              <div className="ml-10">
                <Typography variant="body1">New Request</Typography>
                <Typography variant="h5">4</Typography>
              </div>
            </div>
          </Card>
        </div>
        <div className="w-full sm:w-1/4 p-16">
          <Card className="relative flex flex-col flex-auto rounded-2xl shadow p-16">
            <div className="flex items-center">
              <Avatar sx={{ bgcolor: '#EAAA05'}}>
                <FuseSvgIcon size={24} color="action">
                material-outline:design_services
                </FuseSvgIcon>
              </Avatar>
              <div className="ml-10">
                <Typography variant="body1">In Progress</Typography>
                <Typography variant="h5">4</Typography>
              </div>
            </div>
          </Card>
        </div>
        <div className="w-full sm:w-1/4 p-16">
          <Card className="relative flex flex-col flex-auto rounded-2xl shadow p-16">
            <div className="flex items-center">
              <Avatar sx={{ bgcolor: '#0597EA'}}>
                <FuseSvgIcon size={24} color="action">
                    material-outline:how_to_reg
                </FuseSvgIcon>
              </Avatar>
              <div className="ml-10">
                <Typography variant="body1">Unplanned Request</Typography>
                <Typography variant="h5">4</Typography>
              </div>
            </div>
          </Card>
        </div>
        <div className="w-full sm:w-1/4 p-16">
          <Card className="relative flex flex-col flex-auto rounded-2xl shadow p-16">
            <div className="flex items-center">
              <Avatar sx={{ bgcolor: '#09D404'}}>
                <FuseSvgIcon size={24} color="action">
                material-outline:check
                </FuseSvgIcon>
              </Avatar>
              <div className="ml-10">
                <Typography variant="body1">Completed Request</Typography>
                <Typography variant="h5">4</Typography>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </>
  );
}
